const DEBUG = 0
const INFO = 1
const WARN = 2
const ERROR = 3
const FATAL = 4
const UNKNOWN = 5

const NAME = 'PurchEase SDK : '

const arrayFromArgs = function arrayFromArgs (args) { return Array.prototype.slice.call(args) }

const consolePolyfilled = console || {}

if (!consolePolyfilled.debug || typeof consolePolyfilled.debug !== 'function') {
  consolePolyfilled.debug = function debug () {
    console.log.apply(this, ['[DEBUG]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.info || typeof consolePolyfilled.info !== 'function') {
  consolePolyfilled.info = function info () {
    console.log.apply(this, ['[INFO]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.warn || typeof consolePolyfilled.warn !== 'function') {
  consolePolyfilled.warn = function warn () {
    console.log.apply(this, ['[WARN]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.error || typeof consolePolyfilled.error !== 'function') {
  consolePolyfilled.error = function error () {
    console.log.apply(this, ['[ERROR]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.fatal || typeof consolePolyfilled.fatal !== 'function') {
  consolePolyfilled.fatal = function fatal () {
    console.log.apply(this, ['[FATAL]'].concat(arrayFromArgs(arguments)))
  }
}
if (!consolePolyfilled.unknown || typeof consolePolyfilled.unknown !== 'function') {
  consolePolyfilled.unknown = function unknown () {
    console.log.apply(this, ['[UNKNOWN]'].concat(arrayFromArgs(arguments)))
  }
}

export default class Logger {
  constructor (level) {
    this.logLevel = level
  }

  _setLogLevel (level) {
    this.logLevel = level
  }
  _apply (func, args) {
    func.apply(console, [NAME].concat(arrayFromArgs(args)))
  }
  debug () {
    if (this.logLevel <= DEBUG) {
      this._apply(consolePolyfilled.debug, arguments)
    }
  }
  info () {
    if (this.logLevel <= INFO) {
      this._apply(consolePolyfilled.info, arguments)
    }
  }
  warn () {
    if (this.logLevel <= WARN) {
      this._apply(consolePolyfilled.warn, arguments)
    }
  }
  error (...args) {
    if (this.logLevel <= ERROR) {
      this._apply(consolePolyfilled.error, arguments)
    }
  }
  fatal () {
    if (this.logLevel <= FATAL) {
      this._apply(consolePolyfilled.fatal, arguments)
    }
  }
  unknown () {
    if (this.logLevel <= UNKNOWN) {
      this._apply(consolePolyfilled.unknown, arguments)
    }
  }
  log () {
    this._apply(consolePolyfilled.log, arguments)
  }
}
